"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPopupConfig = addPopupConfig;
exports.deletePopupConfig = deletePopupConfig;
exports.enablePopupConfig = enablePopupConfig;
exports.getPopupConfigDetail = getPopupConfigDetail;
exports.getPopupConfigPage = getPopupConfigPage;
exports.getPopupInfo = getPopupInfo;
exports.getShops = getShops;
exports.queryCdpGroupList = queryCdpGroupList;
exports.queryPageList = queryPageList;
exports.saveOrUpdatePopupConfig = saveOrUpdatePopupConfig;
exports.updatePopupConfig = updatePopupConfig;
exports.updatePopupConfigStatus = updatePopupConfigStatus;
exports.updatePopupFieldStatus = updatePopupFieldStatus;
exports.updatePopupShowStatus = updatePopupShowStatus;
exports.uploadPopupImage = uploadPopupImage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 分页查询弹窗配置
function getPopupConfigPage(query) {
  return (0, _requestAuth.default)({
    url: "/xyPopUp/page",
    method: "get",
    params: query
  });
}

// 新增弹窗配置
function addPopupConfig(data) {
  return (0, _requestAuth.default)({
    url: "/xyPopUp",
    method: "post",
    data: data
  });
}

// 编辑弹窗配置
function updatePopupConfig(data) {
  return (0, _requestAuth.default)({
    url: "/xyPopUp",
    method: "put",
    data: data
  });
}

// 保存或修改弹窗配置（根据ID判断是新增还是修改）
function saveOrUpdatePopupConfig(data) {
  return (0, _requestAuth.default)({
    url: "/xyPopUp/saveOrUpdate",
    method: "post",
    data: data
  });
}

// 删除弹窗配置
function deletePopupConfig(id) {
  return (0, _requestAuth.default)({
    url: "/xyPopUp/delete/".concat(id),
    method: "delete"
  });
}

// 修改弹窗配置状态
function updatePopupConfigStatus(id) {
  return (0, _requestAuth.default)({
    url: "/xyPopUp/enable",
    method: "get",
    params: {
      id: id
    }
  });
}

// 获取弹窗配置详情
function getPopupConfigDetail(id) {
  return (0, _requestAuth.default)({
    url: "/xyPopUp/".concat(id),
    method: "get"
  });
}

// 根据ID获取弹窗详情（/info/{id} 路径）
function getPopupInfo(id) {
  return (0, _requestAuth.default)({
    url: "/xyPopUp/info/".concat(id),
    method: "get"
  });
}

// 上传图片，返回URL
function uploadPopupImage(file) {
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestAuth.default)({
    url: '/xyPopUp/uploadPic',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 启用/禁用弹窗
function enablePopupConfig(id) {
  return (0, _requestAuth.default)({
    url: "/xyPopUp/enable",
    method: "get",
    params: {
      id: id
    }
  });
}

// 获取页面列表信息
// 返回 [{ pageUrl, pageName }]，自定义页面装修(zdy_dragging)的内部链接选择同样使用此接口
function queryPageList() {
  return (0, _requestAuth.default)({
    url: '/xyPopUp/queryPageList',
    method: 'get'
  });
}

// 获取门店信息
function getShops() {
  return (0, _requestAuth.default)({
    url: '/xyPopUp/getShops',
    method: 'get'
  });
}

// 查询cdp分组或消费行为信息
function queryCdpGroupList(params) {
  return (0, _requestAuth.default)({
    url: '/xyPopUp/queryCdpGroupList',
    method: 'get',
    params: params
  });
}

// 更新弹窗配置字段状态（通用方法）
function updatePopupFieldStatus(id, fieldName) {
  return (0, _requestAuth.default)({
    url: '/xyPopUp/updateFieldStatus',
    method: 'get',
    params: {
      id: id,
      fieldName: fieldName
    }
  });
}

// 更新弹窗配置展示状态
function updatePopupShowStatus(id) {
  return updatePopupFieldStatus(id, 'isShow');
}